<!-- 教育局-评价预警 -->
<template>
  <div>
    <div class="index" v-show="!detail.show">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
      </div>

      <div class="Homeboxtop_nav_tab" v-if="org_type!='a'">
				<span v-for="(item, index) in tabList" :class="['res-tab', { active: item.area_name === tabName }]" :key="index+item.area_name" @click="tabClick(item)">
					{{ item.area_name }}
				</span>
			</div>

      <!-- <header class="m-t">
        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>评价热度</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>评价分布</span>
          </div>
          <div id="echarts-box2"></div>
        </div>
      </header> -->

      <div class="header-item-title">
        <span class="circle"></span>
        <span>评价风险详情</span>
      </div>
      <div class="Homeboxtop_nav_tab m-t">
				<span v-for="(item, index) in tabList_1" :class="['res-tab', { active: item === tabName_1 }]" :key="index+item" @click="tabClick_1(item)">
					{{ item }}
				</span>
			</div>
      <div class="m-t">
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <!-- 机构 -->
          <template v-if="tabName_1==='机构'">
          <el-form-item label="">
            <el-input v-model="queryParams.name" placeholder="请输入机构名称"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="queryParams.time"
              type="daterange"
              style="width: 240px"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          </template>
          <!-- 学校 -->
          <template v-if="tabName_1==='学校'">
          <el-form-item label="">
            <el-input v-model="queryParams_1.name" placeholder="请输入学校名称"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="queryParams_1.time"
              type="daterange"
              style="width: 240px"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          </template>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>

        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="orgName" label="机构" align="center" v-if="tabName_1==='机构'">
            </el-table-column>
            <el-table-column prop="orgName" label="学校" align="center" v-if="tabName_1==='学校'">
            </el-table-column>
            <el-table-column prop="areaName" v-if="org_type!='a'" label="所属区域" align="center">
            </el-table-column>
            <el-table-column prop="frontEvaluateNumber" label="正面评价数" align="center">
            </el-table-column>
            <el-table-column prop="neutralEvaluateNumber" label="中性评价数" align="center">
            </el-table-column>
            <el-table-column prop="negativeEvaluateNumber" label="负面评价数" align="center">
            </el-table-column>
            <!-- <el-table-column prop="riskGrade" label="评价风险等级" align="center">
              <template slot-scope="scope">
                 {{rickObj[scope.row.riskGrade]}}
              </template>
            </el-table-column> -->
          </el-table>
          <div class="pagination" v-show="tabName_1==='机构'">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
          <div class="pagination" v-show="tabName_1==='学校'">
            <el-pagination
              background
              :current-page="pageNum_1"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize_1"
              :total="totalPage_1"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/education/index.js";
import * as echarts from "echarts";
import dayjs from 'dayjs';
export default {
  components: {},
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      pageNum_1: 1,
      pageSize_1: 10,
      totalPage_1: 0,
      queryParams: {
        name: "",
        time: "",
        risk: "",
      },
      queryParams_1:{
        name: "",
        time: "",
        risk: "",
      },
      riskList: [
        { id: 2, label: "高" },
        { id: 1, label: "中" },
        { id: 0, label: "低" },
      ],
      rickObj:{
        0:'低',
        1:'中',
        2:'高',
      },
      tableData: [],
      detail: {
        info: {},
        show: false,
      },
      weekDate: [],
      pickerOptions: {
        disabledDate(time) {
          // return time.getTime() > Date.now();
        },
      },
      tabList: [],
      userInfo:JSON.parse(sessionStorage.getItem('userInfo')),
      tabName:'全省',
			provinceCode:'',	// 省编码
			cityCode:'',	// 市编码
			areaCode:'',	// 区编码
      tabList_1:['机构', '学校'],
      tabName_1:'机构',
    };
  },
  watch: {
    tabName(n,o){
			let arr = this.tabList.filter(e=>e.area_name===n);
			if(this.org_type==='p'){
				if(n==='全省'){
					this.cityCode='';
				}else{
					this.cityCode=arr[0].area_code;
				}
			}else{
				if(n==='全市'){
					this.areaCode='';
				}else{
					this.areaCode=arr[0].area_code;
				}
			}
			this.getDataList();
		},
    tabName_1(n,o){
      this.getDataList();
    },
  },
  computed:{
		// 教育局级别判断	省级:99  市级:1,10  区县级:2,20,4,40
	 org_type(){
			let str = 'a';
			if(sessionStorage.getItem("user_level") === "99"){
				str = 'p'
			}
			if(["1", "10"].indexOf(sessionStorage.getItem("user_level")) > -1){
				str = 'c'
			}
      if(["2", "20","4", "40"].indexOf(sessionStorage.getItem("user_level")) > -1){
				str = 'a'
			}
			return str;
		},
	},
  created() {
    if(this.org_type!=='a'){
      let areaList=JSON.parse(sessionStorage.getItem('areaList'))||[]
      if(this.org_type==='p'){
        this.provinceCode=this.userInfo.province_code;
        this.tabList=[
          {area_name:'全省',area_code:this.userInfo.province_code},
          ...areaList,
        ]
      }else{
        this.provinceCode=this.userInfo.province_code;
        this.cityCode=this.userInfo.city_code;
        this.tabList=[
          {area_name:'全市',area_code:this.userInfo.city_code},
          ...areaList,
        ]
      }
      this.tabName=this.tabList[0].area_name;
    }else{
      this.provinceCode=this.userInfo.province_code || '';
      this.cityCode=this.userInfo.city_code || '';
      this.areaCode=this.userInfo.area_code || '';
    }
    this.getDataList();
  },
  methods: {
    tabClick(item) {
      this.tabName = item.area_name;
    },
    tabClick_1(item) {
      this.tabName_1 = item;
    },
    async getDataList() {
      let form={}, page=1, limit=10, type=8, start='', end='';
      if(this.tabName_1==='机构'){
        form=this.queryParams;
        page=this.pageNum;
        limit=this.pageSize;
        type=8;
      }else{
        form=this.queryParams_1;
        page=this.pageNum_1;
        limit=this.pageSize_1;
        type=2;
      }
      if(form.time){
				start=dayjs(form.time[0]).format('YYYY-MM-DD');
				end=dayjs(form.time[1]).format('YYYY-MM-DD');
			}
      let params = {
        pageNum: page,
        pageSize: limit,
        type: type,
        provinceCode:this.provinceCode,
        cityCode:this.cityCode,
        areaCode:this.areaCode,
        orgName:form.name,
        riskGrade:form.rick,
        startTime:start,
        endTime:end,
      };
      let res = await api.getRiskwarningEducationEvaluate(params);
      if(res.result==='000000'){
        this.tableData=res.data.list;
        if(this.tabName_1==='机构'){
          this.totalPage=res.data.total;
        }else{
          this.totalPage_1=res.data.total;
        }
      }
    },
    searchFun() {
      if(this.tabName_1==='机构'){
        this.pageNum = 1;
      }else{
        this.pageNum_1 = 1;
      }
      this.getDataList();
    },
    sizeChangeHandle(val) {
      if(this.tabName_1==='机构'){
        this.pageSize = val;
      }else{
        this.pageSize_1 = val;
      }
      this.getDataList();
    },
    currentChangeHandle(val) {
      if(this.tabName_1==='机构'){
        this.pageNum = val;
      }else{
        this.pageNum_1 = val;
      }
      this.getDataList();
    },
    init() {
      let vm = this;
      this.$nextTick(() => {
        // 圆环图
        let chartDom1 = document.getElementById("echarts-box1");
        let myChart1 = echarts.init(chartDom1);
        let option1 = {
          tooltip: {
            trigger: "axis",
          },
          legend: {
            left: "center",
            top: "bottom",
            icon: "circle",
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.weekDate,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              name: "日",
              type: "line",
              data: [740, 832, 634, 612, 981, 716, 618],
            },
            {
              name: "周",
              type: "line",
              data: [562, 720, 660, 785, 817, 901, 989],
            },
            {
              name: "月",
              type: "line",
              data: [712, 674, 710, 901, 868, 696, 729],
            },
            {
              name: "年",
              type: "line",
              data: [602, 814, 710, 911, 888, 786, 669],
            },
          ],
          color: ["#5BB0FF", "#51D6A6", "#EFD051", "#F04C0B"],
        };
        myChart1.setOption(option1);

        // 折线图
        let chartDom2 = document.getElementById("echarts-box2");
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          tooltip: {
            trigger: "axis",
          },
          legend: {
            left: "center",
            top: "bottom",
            icon: "circle",
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.weekDate,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              name: "正面",
              type: "line",
              data: [440, 232, 431, 312, 281, 256, 288],
            },
            {
              name: "负面",
              type: "line",
              data: [302, 340, 400, 215, 387, 161, 309],
            },
            {
              name: "中性",
              type: "line",
              data: [302, 304, 340, 321, 308, 316, 309],
            },
          ],
          color: ["#5BB0FF", "#51D6A6", "#EFD051"],
        };
        myChart2.setOption(option2);
      });
    },
  },
  mounted() {
    let arr = [];
    for (let i = 1; i <= 7; i++) {
      const time = new Date(new Date().setDate(new Date().getDate() + i - 7));
      const year = time.getFullYear();
      const month = `0${time.getMonth() + 1}`.slice(-2);
      const strDate = `0${time.getDate()}`.slice(-2);
      arr.push(`${month}-${strDate}`);
    }
    this.weekDate = arr;
    // this.init();
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }

  header {
    width: 100%;
    height: 350px;
    display: flex;
    .header-item {
      width: 50%;

      .header-item-text {
        font-size: 14px;
        color: #666;
        padding-left: 20px;
        margin-top: 5px;
      }
    }
    #echarts-box1 {
      width: 80%;
      height: 280px;
    }
    #echarts-box2 {
      width: 90%;
      height: 280px;
    }
  }
  .header-item-title {
    font-size: 18px;
    color: #333;
    display: flex;
    align-items: center;
    .circle {
      width: 8px;
      height: 8px;
      display: inline-block;
      background: #4991e1;
      border-radius: 50%;
      margin-right: 10px;
    }
  }
  .Homeboxtop_nav_tab {
    span {
      padding-bottom: 10px;
    }
  }
}
</style>
